import styled from 'styled-components';
import { Head } from "@/features/pages/home";

export const CenteredHead = styled(Head)`
  @media (max-width: 800px) {
    text-align: center;
    align-items: center;
  }
`;

export const BgFigure = styled.div`
  position: absolute;
  z-index: 2;
  width: 530px;
  height: 80%;
  bottom: 65px;
  right: 0px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: right;
  }
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  position: relative;
  z-index: 10;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
